import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'

export const Card = styled(DefaultCard)(({ theme }) => ({
  flex: 'none',
  gap: theme.space['24'],
  height: 'auto',
}))

export const InfoGrid = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['20'],
  justifyContent: 'space-between',
}))

export const InfoField = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.space['8'],
}))

export const InfoFieldText = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const BodySection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const AnnouncementImage = styled.img(({ theme }) => ({
  borderRadius: theme.border.radius['8'],
  height: 'auto',
  maxHeight: '10rem',
  objectFit: 'cover',
  width: '10rem',
}))

export const AttachmentList = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['8'],
  gridTemplateColumns: 'repeat(auto-fill, minmax(68rem, 1fr))',
}))

export const ShowMoreButton = styled.button(({ theme }) => ({
  alignSelf: 'flex-start',
  background: 'none',
  border: 'none',
  color: theme.colors.black800,
  cursor: 'pointer',
  fontSize: '1.2rem',
  fontWeight: 600,
  lineHeight: '1.6rem',
  padding: 0,
  textDecoration: 'underline',
}))
